export enum CustomizationRequestStatusEnum {
  Draft = 1,
  ApprovedByRequestingUser = 2,
  GraphicallyApproved = 3,
  CommerciallyApproved = 4,
  Rejected = 5,
  Ordered = 6,
}

export enum CustomizationRequestStatusVMEnum {
  DraftWithNotification = 0,
  DraftWithoutNotification = 1,
  ApprovedByRequestingUser = 2,
  GraphicallyApproved = 3,
  CommerciallyApproved = 4,
  Rejected = 5,
  Ordered = 6
}
